import layout1 from './layout1/Layout1Config'

const themeLayoutConfigs = {
	layout1,
}

export default themeLayoutConfigs
